export const CONTACT_API_URL = 'https://api.jcarron.net/contact';
export const TURNSTILE_SITE_KEY = '0x4AAAAAAEv3RvF_Iu59WR2Q';
